import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import classNames from "classnames";
import Button from "../Button";
import ButtonDropDown from "../ButtonDropDown";
import useStyles from "./styles";
const warnNotButton = component => {
  // eslint-disable-next-line no-console
  console.error("ButtonGroup only supports buttons nested directly within or one level below the ButtonGroup. This ButtonGroup contains an item that doesn't meet this criteria.");
  return component;
};
const ButtonGroup = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    layout = "left",
    className,
    children,
    ...otherProps
  } = props;
  const classes = useStyles(props);
  const buttonClassNames = classNames({
    [classes.alignLeft]: layout === "left",
    [classes.alignRight]: layout === "right",
    [classes.splitButton]: layout === "justify",
    [classes.alignCenter]: layout === "center",
    [classes.stackedButton]: layout === "stacked"
  });
  return /*#__PURE__*/React.createElement("div", _extends({}, otherProps, {
    ref: ref,
    className: classNames("prmbl-buttonGroup", className, {
      [classes.rightButtons]: layout === "right",
      [classes.justifiedButtons]: layout === "justify",
      [classes.centerButtons]: layout === "center",
      [classes.root]: layout === "left" || layout === "center" || layout === "right"
    })
  }), React.Children.map(children, Child => {
    if (/*#__PURE__*/React.isValidElement(Child)) {
      // If the child is a button, apply className to the child
      if (Child.type === Button || Child.type === ButtonDropDown) {
        return /*#__PURE__*/React.cloneElement(Child, {
          className: classNames(Child.props.className, buttonClassNames)
        });
      }
      // If the child contains a button one level deep, apply classnames to that button
      else if (Child.props.children.type === Button || Child.props.children.type === ButtonDropDown) {
        // We don't know what the parent's type is here
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return /*#__PURE__*/React.cloneElement(Child, {
          children: /*#__PURE__*/React.cloneElement(Child.props.children, {
            className: classNames(Child.props.children.props.className, buttonClassNames)
          })
        });
      } // Doesn't appear to be a button, don't apply classnames
      return warnNotButton(Child);
    }
  }));
});
ButtonGroup.displayName = "ButtonGroup";
ButtonGroup.defaultProps = {
  layout: "left"
};
export { ButtonGroup };
export default ButtonGroup;